module.exports = __webpack_public_path__ + "static/media/bird.23b097dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/bird.svg
// module id = 116
// module chunks = 0